import { PractitionerView } from '@dreryk/egabinet-personnel-frontend-api';

import { createTranslatedText } from '@dreryk/react-common';
import { LinkVariant } from '@dreryk/react-components';

import { StyledPractitionerNameLink } from './PractitionerNameLink.styled';

export type PractitionerNameLinkProps = {
   readonly onClick?: VoidFunction;
   readonly practitioner: PractitionerView;
};

export const PractitionerNameLink = (props: PractitionerNameLinkProps): JSX.Element => {
   return (
      <StyledPractitionerNameLink
         testId={'practitioner'}
         active={false}
         onClick={props.onClick}
         variant={LinkVariant.PRIMARY}
         label={createTranslatedText(
            `${props.practitioner.lastName.asString()} ${props.practitioner.firstName.asString()}`
         )}
      />
   );
};
